export const RESIDENCY_STATUS_DATA = [
  { label: 'Home', value: 'home' },
  { label: 'Rent', value: 'rent' },
  { label: 'Condo', value: 'condo' },
  { label: 'Mobile Home', value: 'mobile_home' },
  { label: 'Other', value: 'other' },
];
